// @flow

import { Link } from 'react-router-dom';
import styled from 'styled-components';

const UnstyledLink = styled<any>(Link)`
  text-decoration: none;
`;

export default UnstyledLink;



// WEBPACK FOOTER //
// ./src/styles/unstyled-link/index.js